module.exports = __webpack_public_path__ + "TC.png?dea8f01b069d0967fe09ab5d0b316709";